module.exports = __webpack_public_path__ + "img/dice-d8.ce3ba7e6.svg";